/* eslint-disable */
import ApiService from "@/services/ApiService";
import AppConfig from "@/utils/AppConfig";
import { apiVerbs, headers } from "@/utils/AppConfig";
export const RoleService = {
    async getAll() {
        var response = await ApiService.query(
            { url: AppConfig.baseUrl + "userRoleAdmin", method: apiVerbs.get },
            headers()
        );

        return response;
    },
    async read(id) {
        var response = await ApiService.query(
            { url: AppConfig.baseUrl + `userRoleAdmin/${id}`, method: apiVerbs.get },
            headers()
        );

        return response;
    },
    async addUserToRole(payload) {
        var response = await ApiService.query(
            { url: AppConfig.baseUrl + "userRoleAdmin/addUserToRole", method: apiVerbs.post, data: payload },
            headers()
        );

        return response;
    },
    async create(payload) {
        var response = await ApiService.query(
            { url: AppConfig.baseUrl + "userRoleAdmin", method: apiVerbs.post, data: payload },
            headers()
        );

        return response;
    },
    async update(id, payload) {
        var response = await ApiService.query(
            { url: AppConfig.baseUrl + `userRoleAdmin/${id}`, method: apiVerbs.put, data: payload },
            headers()
        );
        return response;
    },
    async delete(id) {
        var response = await ApiService.query(
            { url: AppConfig.baseUrl + `userRoleAdmin/${id}`, method: apiVerbs.delete },
            headers()
        );
        return response;
    }

};